import { AfterViewInit, Component, ElementRef, HostBinding, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { RendererType } from '../../models/sections-model';
import { AnimationTriggerNames } from '@angular/compiler';

@Component({
  selector: 'kw-wrapper',
  templateUrl: './wrapper.component.html',
  styleUrls: ['./wrapper.component.scss']
})
export class WrapperComponent implements OnChanges{
  @Input() rendererType:RendererType;
  @Input() numberOfElements:number;
  @Input() gap:number;
  @Input() wrapperClass:string;
  @Input() bgColor:string;
  @Input() border:string;
  @Input() borderRadius:string;

  @HostBinding('style.--section-background')
  sectionBackground: string = "var(--color-primary-200)";
  @HostBinding('style.--section-border')
  sectionBorder: string = "none"
  @HostBinding('style.--section-border-radius')
  sectionBorderRadius:string = "none";

  observer:ResizeObserver;

  contentHost:HTMLElement;
  originWidth:number;

  @ViewChild('contentWrapper',{read:ElementRef}) contentWrapper:ElementRef<HTMLElement>

  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["bgColor"]){
      this.sectionBackground = this.bgColor;
      //this.sectionBorder = "solid 3px #000";
      //this.sectionBorderRadius = "5px";
    }
    if(changes["border"]){
      console.log(this.border)
      this.sectionBorder = this.border
    }
    if(changes["borderRadius"]){
      console.log(this.borderRadius)
      this.sectionBorderRadius = this.borderRadius
    }
  }

  
  
  





  







}
